import { ExamContextHandler } from 'Core/ContextHandler/ExamContextHandler'
import { TaskContextHandler } from 'Core/ContextHandler/TaskContextHandler'
import { ContainerType, ContextType } from 'Types/Tasks.types'
import { ContextHandlerConfigType } from './IContextHandler'

export class ContextHandlerFactory {
    static createFor<T extends ContainerType, U>(
        contextType: ContextType,
        config: ContextHandlerConfigType<T, U>
    ) {
        switch (contextType) {
            case ContextType.ExamTask:
                return new ExamContextHandler(config)
            default:
                return new TaskContextHandler(config)
        }
    }
}
